import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customNumberFormat',
  standalone: true,
})
export class CustomNumberFormatPipe implements PipeTransform {
  transform(value: number | string | undefined): string {
    // Return a dash if the value is null or undefined
    if (value === undefined || value === null) {
      return '-';
    }

    // Convert string to number (replace comma with dot for parsing)
    const numericValue =
      typeof value === 'string' ? parseFloat(value.replace(/ /g, '').replace(',', '.')) : value;

    // Check if the value is a valid number
    if (!isNaN(numericValue)) {
      if (numericValue === 0) {
        return '0'; // Return zero as-is
      } else {
        // Format number with two decimal places
        let formattedNumber = numericValue.toFixed(2);

        // Replace decimal point with comma
        formattedNumber = formattedNumber.replace('.', ',');

        // Split integer and decimal parts
        const [intPart, decimalPart] = formattedNumber.split(',');

        // Add space every three digits in the integer part
        const intPartWithSpaces = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

        // Remove ",00" if the decimal part is 00
        if (decimalPart === '00') {
          return intPartWithSpaces;
        }

        // Return the formatted number with comma and decimal part
        return `${intPartWithSpaces},${decimalPart}`;
      }
    }

    // If value is not a valid number, return it as a string
    return value.toString();
  }
}
